import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { AccountingService } from 'src/app/services/accounting/accounting.service';
import * as moment  from 'moment';

@Component({
  selector: 'app-vendor',
  templateUrl: './vendor.component.html',
  styleUrls: ['./vendor.component.css']
})
export class VendorComponent implements OnInit {

 
  constructor(private accService:AccountingService,private spinnerService: Ng4LoadingSpinnerService,private lookupService:LookupService,public globalHelper :GlobalHelper) { }
  currentPage = 1;
  pageSize = 20;
  recordCount = 0;
  totalPages = 0;
  numberOfPages () {
      this.totalPages = Math.ceil(this.recordCount / this.pageSize);
  }

  nextPage () {
      this.currentPage = this.currentPage + 1;

  }

  pageSizes () {
      this.currentPage = 1;
      this.recordCount = 0;
      this.totalPages = 0;

  }
  VendorModel = {
    TransDetID:0,
      VendorID: 0,
      VendorCode: '',
      VendorName: '',
      VendorType: 0,
      Type: 0,
      Address: '',
      CityID: 0,
      StateID: 0,
      CountryID: 0,
      PinCode: '',
      MobileNo: '',
      PhoneNo: '',
      SubMasterAccountID: 0,
      ParentID: 0,
      VendorAccountName: '',
      VendorBalance: 0,
      VendorAccountID: 0,
      FaxNo: '',
      Email: '',
      ContactPersonName: '',
      ContactPersonEmail: '',
      PostBoxNo: '',

  };
  SearchVendorModel = {
      VendorID: 0,
      VendorCode: '',
      VendorName: '',
      VendorType: 0,
      Type: 0,
      Address: '',
      CityID: 0,
      StateID: 0,
      CountryID: 0,
      PinCode: '',
      MobileNo: '',
      PhoneNo: '',
      SubMasterAccountID: 0,
      ParentID: 0,
      VendorAccountName: '',
      VendorBalance: 0,
      VendorAccountID: 0,
      FaxNo: '',
      Email: '',
      ContactPersonName: '',
      ContactPersonEmail: '',
      PostBoxNo: '',
      CurrentIndex:0,
      PageSize:0,

  };
  SelectedRowID = 0;
  SearchClear () {
      this.SelectedRowID = 0;
      this.SearchVendorModel.VendorID = 0;
      this.SearchVendorModel.VendorCode = '';
      this.SearchVendorModel.VendorType = 0;
      this.SearchVendorModel.Type = 0;
      this.SearchVendorModel.VendorName = '';

  };
  Submitted = false;
  Clear () {
      this.SelectedRowID = 0;
      this.Submitted = false;
      this.VendorModel.VendorID = 0;
      this.VendorModel.VendorCode = '';
      this.VendorModel.VendorType = 0;
      this.VendorModel.Type = 0;
      this.VendorModel.VendorName = '';
      this.VendorModel.Address = '';
      this.VendorModel.CityID = 0;
      this.VendorModel.ParentID = 0;
      this.VendorModel.CountryID = 0;
      this.VendorModel.StateID = 0;
      this.VendorModel.PinCode = '';
      this.VendorModel.MobileNo = '';
      this.VendorModel.PhoneNo = '';
      this.VendorModel.SubMasterAccountID = 0;
      this.VendorModel.VendorAccountName = '';
      this.VendorModel.VendorBalance = 0;
      this.VendorModel.VendorAccountID = 0;
      this.VendorModel.PostBoxNo = '';
      this.VendorModel.ContactPersonEmail = '';
      this.VendorModel.ContactPersonName = '';
      this.VendorModel.Email = '';
      this.VendorModel.FaxNo = '';
  };

  ValidateDropdownSave() {
      return this.VendorModel.VendorName == '' || this.VendorModel.VendorType == 0 || this.VendorModel.Type == 0
  };

 
  lodingSave = false;
  Save () {
      this.Submitted = true;

      if (!this.ValidateDropdownSave()) {
          this.lodingSave = true;
          this.VendorModel.VendorAccountName = this.VendorModel.VendorName;
          this.accService.SaveVendor(JSON.stringify(this.VendorModel)).subscribe((response) =>{
              this.globalHelper.CheckActionStatus(response);
              if (response.webResponse.Status) {
                  if (this.VendorModel.VendorID == 0) {
                      this.Clear();
                  }

                  this.GetAllVendor();
              }
              this.lodingSave = false;
          });
      }
  };
  CountryList:any;
  GetCountry () {
      this.lookupService.GetLookupsList('Country', '').subscribe((data) =>{
          this.CountryList = data.LookupItems;
      });
  };
  StateList:any;
  GetState () {
     
      var ItemBO = {
          ItemId: this.VendorModel.CountryID
      }
      this.lookupService.GetLookupsList('State', JSON.stringify(ItemBO)).subscribe((data) =>{
          this.StateList = data.LookupItems;
      });
  };

  VendorList: any;
  CityList:any;
  GetCity () {
      var ItemBO = {
          ItemId: this.VendorModel.StateID
      }
      this.lookupService.GetLookupsList('City', JSON.stringify(ItemBO)).subscribe((data) =>{
          this.CityList = data.LookupItems;
      });
  }


  //this.AccountGroup () {
  //    this.lookupService.GetLookupsList('GroupAcc', '').subscribe((data) =>{
  //        this.AccountGroupList = data.LookupItems;
  //    });
  //}
  loadingSearch = false;
  GetAllVendor () {

      this.SearchVendorModel.CurrentIndex = this.currentPage;
      this.SearchVendorModel.PageSize = this.pageSize;
      this.loadingSearch = true;
      this.spinnerService.show()
      this.accService.GetAllVendor(JSON.stringify(this.SearchVendorModel)).subscribe((data) =>{
          this.VendorList = data.VendorList;
          this.recordCount = 0;
          if (data.VendorList != null && data.VendorList.length > 0) {
              this.recordCount = data.VendorList[0].RecordCount;
          }

          this.spinnerService.hide()
          this.loadingSearch = false;
          this.numberOfPages();
      });
  };

  Edit (obj) {
      this.SelectedRowID = obj.VendorID;

      this.VendorModel.VendorID = obj.VendorID;
      this.VendorModel.VendorCode = obj.VendorCode;
      this.VendorModel.VendorName = obj.VendorName;
      this.VendorModel.Address = obj.Address;
      this.VendorModel.CountryID = obj.CountryID;
      this.VendorModel.ParentID = obj.ParentID;
      this.VendorModel.VendorType = obj.VendorType;
      this.VendorModel.Type = obj.Type;
      this.VendorModel.TransDetID = obj.TransDetID;
      this.GetState();
      this.VendorModel.StateID = obj.StateID;
      this.GetCity();
      this.VendorModel.CityID = obj.CityID;
      this.VendorModel.PinCode = obj.PinCode;
      this.VendorModel.MobileNo = obj.MobileNo;
      this.VendorModel.PhoneNo = obj.PhoneNo;
      this.VendorModel.SubMasterAccountID = obj.SubMasterAccountID;
      this.VendorModel.VendorAccountID = obj.VendorAccountID;
      this.VendorModel.VendorAccountName = obj.VendorAccountName;
      this.VendorModel.VendorBalance = obj.VendorBalance;
      this.VendorModel.FaxNo = obj.FaxNo;
      this.VendorModel.Email = obj.Email;
      this.VendorModel.ContactPersonName = obj.ContactPersonName;
      this.VendorModel.ContactPersonEmail = obj.ContactPersonEmail;
      this.VendorModel.PostBoxNo = obj.PostBoxNo;
  };


  


  ngOnInit() {
    this.GetAllVendor();
    this.GetCountry();
  }

}
